<template>
     <div class="w_inner">

          <div class="innerWrap">
               <div class="main_container">
                    <div class="about_content culture" id="culture">
                         <div v-if="currentLang=='zh'" class="cultureShow" :style="'background: url(' + CompanyInfo.aboutTopImg + ') center top no-repeat;height:1080px;'"></div>
                         <div v-else class="cultureShow" :style="'background: url(' + CompanyInfo.aboutTopImgEn + ') center top no-repeat;height:1080px;'"></div>
                    </div>

                    <div class="about_content course" id="course">
                         <div v-if="currentLang=='zh'" class="cultureShow" :style="' background: url(' + CompanyInfo.historyImg + ') center top no-repeat;height:1080px;'"></div>
                         <div v-else class="cultureShow" :style="' background: url(' + CompanyInfo.historyImgEn + ') center top no-repeat;height:1080px;'"></div>
                    </div>

                    <div class="about_content layout" id="layout">
                         <div class="layoutShow w">
                              <div class="title">{{$t('about.layout')}}</div>
                              <div class="list">
                                   <div class="swiper-container">
                                        <div class="swiper-wrapper">
                                             <div class="swiper-slide item" v-for="(item, index) in layoutList" :key="index">
                                                  <div class="img">
                                                       <img v-if="currentLang=='zh'" :src="item.img" alt="">
                                                       <img v-else :src="item.enimg" alt="">
                                                  </div>
                                                  <div v-if="currentLang=='zh'" class="tishow">{{ item.title }}</div>
                                                  <div v-else class="tishow">{{ item.entitle }}</div>
                                             </div>
                                        </div>
                                        <div class="swiper-pagination"></div>
                                   </div>
                              </div>
                         </div>
                    </div>
                    <div class="about_content course" id="course">
                         <div v-if="currentLang=='zh'" class="cultureShow" :style="' background: url(' + CompanyInfo.coreCompetenceImg + ') center top no-repeat;height:1080px;'"></div>
                         <div v-else class="cultureShow" :style="' background: url(' + CompanyInfo.coreCompetenceImgEn + ') center top no-repeat;height:1080px;'"></div>
                    </div>
                    <div class="about_content research" id="Research">
                         <div class="researchShow w">
                              <div class="title">{{$t('about.introduction')}}</div>
                              <div class="swiper-container1">
                                   <div class="swiper-wrapper">
                                        <div class="swiper-slide item" v-for="(item, index) in resarchList">
                                             <img :src="item" alt="">
                                        </div>
                                   </div>
                                   <div class="swiper-pagination1"></div>
                              </div>
                         </div>
                    </div>

               </div>
          </div>
     </div>

</template>

<script>
import { mapState } from 'vuex'
import WOW from "../../node_modules/wowjs/dist/wow";
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
export default {
     data() {
          return {
               partner_list: [],
               layoutList: [],
               resarchList: [],
               imgList: [],
               currentLang:this.$i18n.locale
          }
     },
     computed: {
          ...mapState({
               CompanyInfo: state => state.CompanyInfo
          })
     },
     created: function () {
          
     },
     mounted() {
          //滚动页面加载动画
          let wow = new WOW.WOW({
               boxClass: "wow",
               animateClass: "animated",
               offset: 0,
               mobile: true,
               live: true
          });
          wow.init();

     },
     components: {

     },
     methods: {
          HandleInfo() {
               this.layoutList = JSON.parse(this.CompanyInfo.researchList);
               this.resarchList = this.currentLang=='zh'? this.CompanyInfo.researchImg.split(','):this.CompanyInfo.researchImgEn.split(',');
               this.InitSwiper();
               this.InitSwiper1();
               this.$nextTick(function () {
                    this.Initwow();
               });
          },
          InitSwiper() {
               this.CompanyInfo.certificationImgs.split(',').map((_item) => {
                    this.imgList.push(_item);
               });
               var _this = this;
               this.$nextTick(() => {
                    this.swiper = new Swiper(".swiper-container", {
                         loop: false,
                         slidesPerView: 3,
                         spaceBetween: 51,
                         slidesPerGroup: 1,
                         speed: 2000,
                         autoplay: true,
                         pagination: {
                              el: ".swiper-pagination",
                              clickable: true,
                         },
                         on: {
                              click: function (event) {
                                   var t = event.target;
                                   if (t && t.getAttribute("index")) {
                                        var _imgViewerIndex = parseInt(t.getAttribute("index"));
                                        //console.log(_imgViewerIndex);
                                        _this.$viewerApi({
                                             options: {
                                                  toolbar: true,
                                                  title: false,
                                                  initialViewIndex: _imgViewerIndex
                                             },
                                             images: _this.imgList,
                                        })
                                   }
                              }
                         }
                    });
               });
          },
          InitSwiper1() {
               var _this = this;
               this.$nextTick(() => {
                    this.swiper = new Swiper(".swiper-container1", {
                         loop: true,
                         slidesPerView: 1,
                         speed: 600,
                         autoplay: {
                              delay: 4000,
                              disableOnInteraction: false,
                         },
                         pagination: {
                              el: ".swiper-pagination1",
                              clickable: true,
                         },
                    });
               });
          },
          Initwow() {
               let wow = new WOW.WOW({
                    boxClass: "wow",
                    animateClass: "animated",
                    offset: 0,
                    mobile: true,
                    live: true
               });
               wow.init();
          }
     },
     watch: {
          CompanyInfo() {
               this.HandleInfo();
          }
     }
};
</script>
